<template>
    <div>
        <div class="row">
            <div class="col mb-3">
                <form action="" method="post" ref="login_form">
                    <div class="form-group">
                        <input type="text" class="form-control form-control-lg" v-model="email"
                               :class="{'is-invalid' : $v.email.$error || errors.email.length}"
                               placeholder="Enter email address">
                        <div class="invalid-feedback" v-if="$v.email.$dirty && !$v.email.required">Please enter your
                            email!
                        </div>
                        <div class="invalid-feedback" v-if="$v.email.$dirty && !$v.email.email">Please enter valid
                            email!
                        </div>
                        <div class="invalid-feedback" v-for="(err, key) in errors.email" :key="key">{{ err }}</div>
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control form-control-lg" v-model="password"
                               :class="{'is-invalid' : $v.password.$error|| errors.password.length}"
                               placeholder="Enter password">
                        <div class="invalid-feedback" v-if="$v.password.$dirty && !$v.password.required">Please enter
                            your password!
                        </div>
                        <div class="invalid-feedback" v-for="(err, key) in errors.password" :key="key">{{ err }}</div>
                    </div>
                    <div class="form-group">
                        <a href="#" @click.prevent="goToForgotPassword" class="btn btn-sm btn-link float-right p-0">Forgot password</a>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col mx-auto">
                <button class="btn btn-info btn-info-gradient btn-lg btn-block"
                        :class="{'is-invalid' : errors.login.length }" :disabled="running" @click="submit">
                    <div class="spinner-border spinner-border-sm" v-if="running"></div>
                    <span v-else>Login</span>
                </button>
                <div v-for="(err, key) in errors.login" :key="key" class="invalid-feedback text-center pt-2">{{ err }}</div>
                <striketrough>
                    or
                </striketrough>
            </div>
        </div>
        <social-buttons :disabled="running" @auth="onSocialAuth" @click="running = true"/>
    </div>
</template>

<script>
import Striketrough from "@/components/support/Striketrough";
import SocialButtons from "@/components/auth/SocialButtons";
import {validationMixin} from 'vuelidate';
import {email, required} from 'vuelidate/lib/validators';
import api from '@/utils/api';
import {EventBus, events} from '@/utils/event-bus';

export default {
        name: "LoginForm",
        mixins: [validationMixin],
        components: {SocialButtons, Striketrough},
        data: () => {
            return {
                email: null,
                password: null,
                errors: {
                    login: [],
                    email: [],
                    password: []
                },
                running: false
            }
        },
        validations: {
            email: {
                required, email
            },
            password: {
                required
            }
        },
        methods: {
            onSocialAuth: function (token) {
                let that = this;
                this.running = true;

                that.errors = Object.fromEntries(Object.entries(this.errors).map(v => [v[0], []]));
                if(this.$store.getters['auth/recommendationCode']){
                    token = {
                        ...token,
                        recommendation_code: this.$store.getters['auth/recommendationCode']
                    }
                }
                if(this.$store.getters['referral/code']){
                    token = {
                        ...token,
                        referral_code: this.$store.getters['referral/code']
                    }
                }
    
                api.socialauth(token).then(response => {
                    let access = response.data.data;
                    that.authSuccess(access);
                }).catch(() => {
                    that.errors.login = ["Problem with social authentication"];
                    this.running = false
                })
            },
            authSuccess: function (accessResponse) {
                let that = this;
                api.token = accessResponse.access_token;
                api.profile().then(response => {
                    that.$store.commit('auth/setAccessToken', accessResponse.access_token);
                    that.$store.commit('auth/setAccessTokenExpiresAt', accessResponse.expires_at);
                    that.$store.commit('auth/setUser', response.data.data);
                    that.$toast.success("Welcome to MySwitchPro!");
                    EventBus.$emit(events.auth.signin);
                }).finally(() => that.running = false);

            },
            submit: function () {
                let that = this;

                that.errors = Object.fromEntries(Object.entries(this.errors).map(v => [v[0], []]));

                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.running = true;
                let data = {
                    email: this.email,
                    password: this.password
                };
                if(this.$store.getters['auth/recommendationCode']){
                    data = {
                        ...data,
                        recommendation_code: this.$store.getters['auth/recommendationCode']
                    }
                }
                api.signin(data).then(response => {
                    let access = response.data.data;
                    that.authSuccess(access);
                }).catch((error) => {
                    if (error.response.status === 400 && error.response.data.error.code === 11111) {
                        that.errors.email = error.response.data.meta.email;
                        that.errors.password = error.response.data.meta.password;
                    } else {
                        that.errors.login = ["Invalid login details!"];
                    }
                    this.running = false
                })
            },
            goToForgotPassword() {
                try {
                    this.$parent.$parent.$parent.$refs.modal.hide()
                }
                // eslint-disable-next-line no-empty
                finally { }
                this.$router.push({name: 'PasswordReset'})
            }
        }
    }
</script>

<style scoped lang="scss">
    input {
        font-size: 1rem;
        padding: 1.5rem 1rem;

        &:focus {
            color: #317AFB;
            border-color: #317AFB;

            &::placeholder {
                color: #317AFB;
            }
        }

    }
</style>
